import { createContext, useContext, useState } from "react";

const ChatBubbleBgContext = createContext();

export const ChatBubbleBgContextProvider = ({ children }) => {
  const [bgColorBubble, setBgColorBubble] = useState("#7104F8");

  return (
    <ChatBubbleBgContext.Provider value={{ bgColorBubble, setBgColorBubble }}>
      {children}
    </ChatBubbleBgContext.Provider>
  );
};

export const useChatBubbleSettings = () => useContext(ChatBubbleBgContext);
